<mp-catalog-card
  [catalog]="catalog()"
  [openTaskIconMap]="openTaskIconMap"
  [isCatalogActive]="catalog().status === 'Assigned'"
  [isCatalogNotAssigned]="catalog().status === 'NotAssigned'"
  (catalogDetailsClick)="catalogDetailsClick.emit($event)"
>
  <mpsm-catalog-supplier-selector
    catalog-card-main-content
    [editMode]="isEditMode()"
    [supplier]="catalog().supplier"
    [platformSuppliers]="platformSuppliers()"
    [isLoadingPlatformSuppliers]="isLoadingPlatformSuppliers()"
    [catalogType]="catalog().type"
    (supplierChange)="changeSupplier($event)"
    (searchTermChange)="supplierSearchTermChanges.emit($event)"
  />

  @if (!catalog().supplier) {
    <button
      catalog-card-footer-actions
      mat-flat-button
      color="accent"
      class="save-supplier-button"
      [disabled]="isCatalogSaveDisabled()"
      (click)="saveSupplier()"
    >
      <mat-icon>check</mat-icon>
      <span>Speichern</span>
    </button>
  }
</mp-catalog-card>
